import gql from 'graphql-tag';

import { profile } from './profile.graphql';
import { roleRequirements } from './roleRequirements.graphql';
export const prospect = gql`
  fragment prospect on Prospect {
    id
    billableStatus
    candidateId
    jobApplicationId
    seekCandidateId
    firstName
    lastName
    email
    phone
    mostRecentJobTitle
    mostRecentCompanyName
    mostRecentRoleMonths
    appliedDate
    bucket
    isRead
    submission {
      __typename
      ... on Submission {
        roleRequirements {
          ...roleRequirements
        }
      }
      ... on Error {
        message
      }
    }
    attachments {
      id
      type
      filename
      isPdf
    }
    position
    state
    noteCount
    emailCount
    prospectCount
    rating {
      rating
    }

    verifications {
      title
      credentialInfo {
        name
        values
      }
    }
    source
    profile {
      ...profile
    }
    matchedQualities {
      qualities {
        id
        isTop
        displayLabel
        relevanceScore
      }
      hasError
    }
  }
  ${profile}

  ${roleRequirements}
`;
